import React, { useState, useEffect } from 'react'
import TrackAwait from 'AccountsIcons/time.svg'
import TrackAwaitDelayed from 'AccountsIcons/timeDelay.svg'
import TrackDone from 'AccountsIcons/tick.svg'
import TrackFail from 'AccountsIcons/cross.svg'
import TrackIdle from 'SVGPath/track-idle.svg'
import Down from 'SVGPath/down-chevron.svg'
import { arrDepFormatter, fireClevertapEvent } from 'AccountsUtils'

const trackIcons = [
  <TrackAwait fill="#339902" />,
  <TrackDone fill="#339902" />,
  <TrackFail fill="#ff3b30" />
]

const statusClass = ['', 'active-tag', '']

// eslint-disable-next-line complexity
const RefundTrackerStepsDesktop = props => {
  const {
    active,
    status,
    msg,
    dueMsgs,
    commonMsg,
    tag,
    first,
    isPWA,
    last,
    type,
    bookingInfo,
    docs,
    indx,
    setOpenDocModalData,
    setOpenRequestCallback,
    colorFlag
  } = props

  let activeClass = (active && status && statusClass[status]) || (status === null && 'c-grey-30')
  const [isCollapsed, toggleCollapse] = useState(true)

  useEffect(() => {
    toggleCollapse(type === 'collapse')
  }, [])
  const toggler = () => {
    if (type === 'collapse') {
      toggleCollapse(!isCollapsed)
    }
  }

  const openDoc = (e, doc) => {
    fireClevertapEvent('View_documents_needed_clicked_desktop')
    setOpenDocModalData(doc)
    setOpenRequestCallback(true)
  }

  const paxDetail = pax => {
    return ` ${String.fromCharCode(183)} ${pax[0]} ${pax.length > 1 ? `+${pax.length - 1}` : ''}`
  }

  activeClass = activeClass || ''
  return (
    <React.Fragment>
      <li className={`flex-1 ${indx === 0 && 'pt-2'}`}>
        <div
          className={`flex
       flex-row py-2
      ${first ? 'flex-start' : ''}
      ${last ? '' : ''}
        ${!last && !first ? 'flex-center' : ''}`}
        >
          <div
            className={`
      ${!last ? 'tracker-icon' : ''}
      ${!last && !first ? ' flex-center' : ''}`}
          >
            <If condition={status === '0'}>
              <If condition={colorFlag && colorFlag.toLowerCase() === 'red'}>
                <TrackAwaitDelayed fill="#ff3c2b" />
                <Else />
                <TrackAwait fill="#339902" />
              </If>
            </If>
            <If condition={status && !(status === '0')}>
              {trackIcons[status]}
              <Else />
              <If condition={!isPWA && !(status === '0')}>
                <TrackIdle />
              </If>
            </If>
          </div>
          <div
            className={`flex-1 ${
              !isPWA || last ? '' : 'pb-4 border-bottom-grey'
            } flex-middle pb-4 mx-2 ${!last ? 'bor-b-dash' : 'bn'}`}
          >
            <div className="flex flex-between flex-middle">
              <If condition={status === '0'}>
                <p
                  className={`fs-16 pt-1
          ${!isPWA && first ? 'ta-left' : ''}
      ${!isPWA && last ? 'ta-right' : ''}
      ${!isPWA && !last && !first ? ' ta-center' : ''} ${activeClass} ${status === '0' &&
                    (docs && docs.length === 0) &&
                    'mob-active-tag'} ${
      (status === '0' || status === '2') &&
                      (colorFlag && colorFlag.toLowerCase() === 'red') ?
        'c-error-500' :
        'green-success'
    }`}
                  onClick={toggler}
                >
                  {tag}
                </p>
                <If condition={dueMsgs && dueMsgs.length > 0 && isCollapsed}>
                  <If condition={status === '0'}>
                    <p
                      className={`fs-caption-2 ${
                        // eslint-disable-next-line no-nested-ternary
                        colorFlag && colorFlag.toLowerCase() === 'red' ?
                          'c-error-500' :
                          tag.toLowerCase() === 'refund generation' ?
                            'color-8a' :
                            'green-success'
                      } max-66`}
                    >
                      {dueMsgs && dueMsgs.join(' ')}
                    </p>
                    <Else />
                    <p
                      className={`fs-caption-2 ${
                        // eslint-disable-next-line no-nested-ternary
                        status ? 'color-8a' : 'c-grey-30'
                      } pt-2 max-66`}
                    >
                      {dueMsgs && dueMsgs.join(' ')}
                    </p>
                  </If>
                </If>
                <Else />
                <p
                  className={`${isPWA ? 'fs-15' : 'fs-16 pt-1'}
          ${!isPWA && first ? 'ta-left' : ''}
      ${!isPWA && last ? 'ta-right' : ''}
      ${!isPWA && !last && !first ? ' ta-center' : ''} ${activeClass} ${status === '0' &&
                    (docs && docs.length === 0) &&
                    'mob-active-tag'} ${(status === '0' || status === '2') &&
                    (colorFlag && colorFlag.toLowerCase() === 'red') &&
                    'c-error-500'}`}
                  onClick={toggler}
                >
                  {tag}
                </p>
                <If condition={dueMsgs && dueMsgs.length > 0 && !isCollapsed}>
                  <If condition={status === '0'}>
                    <p
                      className={`fs-caption-2 ${
                        // eslint-disable-next-line no-nested-ternary
                        colorFlag && colorFlag.toLowerCase() === 'red' ?
                          'c-error-500' :
                          tag.toLowerCase() === 'refund generation' ?
                            'color-8a' :
                            'green-success'
                      } max-66`}
                    >
                      {dueMsgs && dueMsgs.join(' ')}
                    </p>
                    <Else />
                    <p
                      className={`fs-caption-2 ${
                        // eslint-disable-next-line no-nested-ternary
                        status ? 'color-8a' : 'c-grey-30'
                      } pt-2 max-66`}
                    >
                      {dueMsgs && dueMsgs.join(' ')}
                    </p>
                  </If>
                </If>
              </If>
              {(msg || dueMsgs) && status === '1' && isCollapsed && (
                <Down
                  className={`arrow-min ${
                    type === 'collapse' && isCollapsed ? '' : 'collapsed-arrow'
                  }`}
                  onClick={toggler}
                />
              )}
            </div>
            <div
              className={`${!isPWA ? 'flex flex-between' : ''} ${
                type === 'collapse' && isCollapsed && status === '1' ? 'collapsed' : ''
              }`}
            >
              <If condition={msg && msg.length > 0}>
                <p className={`fs-caption-2 ${status ? 'color-8a' : 'c-grey-30'} pt-2 max-66`}>
                  {msg.join(' ')}
                </p>
              </If>
              <If condition={bookingInfo}>
                <p className={`fs-14 ${status ? 'color-8a' : 'c-grey-30'} pt-2`}>
                  {arrDepFormatter(
                    bookingInfo.departure,
                    bookingInfo.arrival,
                    bookingInfo.journeyType
                  )}
                  <span className="tt-capital">{paxDetail(bookingInfo.paxNames)}</span>
                </p>
              </If>
              <If condition={commonMsg && commonMsg.length > 0 && active}>
                {commonMsg.map(item => (
                  <p
                    className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                      status ? 'color-8a' : 'c-grey-30'
                    } pt-2 max-66`}
                  >
                    {item}
                  </p>
                ))}
              </If>
            </div>
            <If condition={docs && docs.length > 0}>
              <p
                className={`${isPWA ? 'fs-13' : 'fs-caption-2'} c-secondary-500 pt-2 pointer`}
                onClick={e => openDoc(e, docs)}
              >
                View documents needed
              </p>
            </If>
          </div>
        </div>
      </li>
    </React.Fragment>
  )
}
export default RefundTrackerStepsDesktop
